export default __webpack_public_path__ + "img/table_benefits-9937b309ad63a6584e2a19849aaeef61.jpg";